module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signin":"Sign in","signup":"Create account","or":"or"},"ru":{"signin":"Войти","signup":"Создать аккаунт","or":"или"}}')
  delete Component.options._Ctor
}
